import React from 'react'
import { MenuItem } from '@mui/material'
import { MENU_SETTINGS_OPTIONS } from '../../helpers/options/options'
import { useTranslation } from 'react-i18next'

interface MenuSettingsProps {
  handleOptionClick: (to: string) => void
}

const MenuMobileSettings = ({ handleOptionClick }: MenuSettingsProps) => {
  const { t } = useTranslation()

  return (
    <nav className="sidebar open right top-space-menu-mobile color-black">
      {MENU_SETTINGS_OPTIONS.map((value, index) => {
        return (
          <MenuItem
            id={`MenuItem-${index}-circle`}
            key={`MenuItem-${index}`}
            className="menu-logged-settings-principal-mobile"
          >
            {`${t(value.principal_label)}`}
            {value.sub_options.map((val, ind) => {
              return (
                <MenuItem
                  id={`MenuItem-${ind}-circle`}
                  key={`MenuItem-${ind}`}
                  className="menu-logged-settings"
                  onClick={() => handleOptionClick(val.to)}
                >
                  {`${t(val.label)}`}
                </MenuItem>
              )
            })}
          </MenuItem>
        )
      })}
    </nav>
  )
}

export default MenuMobileSettings

function handleOptionClick(principal_label: string): void {
  throw new Error('Function not implemented.')
}
